import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ViewEncapsulation } from '@angular/core';
import { NavigationService } from './navigation.service';
import { AuthService } from '../../services/authentication/auth.service';
import { PermissionEnum } from '../../enumerations/permission-enum';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NavigationComponent implements OnDestroy {

  navigationModel: any[];
  navigationModelChangeSubscription: Subscription;
  loginType: number = window["loginType"];

  @Input('layout') layout = 'vertical';

  constructor(
    private navigationService: NavigationService,
    private authService: AuthService) { 
    this.navigationModelChangeSubscription = this.navigationService.onNavigationModelChange.subscribe((navigationModel) => {
      if (this.loginType == 3) {
        if (authService.isAuthenticated()) {
          navigationModel.forEach(item => {
            if (item.type != 'item' && item.children.length > 0) {
              this.verifyItem(item);
            }
            else {
              if (this.authService.user.permission.find(module => module.Code == item.id) != undefined &&
                this.authService.user.permission.find(module => module.Code == item.id) != null) {
                item.visible = true;
              }
            }
          });
          this.navigationModel = navigationModel;
        }
      }
      else
        this.navigationModel = navigationModel;
    });
  }

  verifyItem(item: any) {
    item.children.forEach(p => {
      if (p.type != 'item' && p.children.length > 0) {
        this.verifyItem(p);
      }
      else {
        var module = this.authService.user.permission.find(module => module.Code == p.id);

        if (module != undefined && module != null) {
          if (module.UserPermissions.find(p => p.PermissionId == PermissionEnum.Visualizar) != undefined) {
            item.visible = true;
            p.visible = true;
          }
        }
      }
    });
  }

  ngOnDestroy() {
    this.navigationModelChangeSubscription.unsubscribe();
  }

}
